import { render } from "./Slot.vue?vue&type=template&id=21044560&scoped=true"
import script from "./Slot.vue?vue&type=script&lang=js"
export * from "./Slot.vue?vue&type=script&lang=js"

import "./Slot.vue?vue&type=style&index=0&id=21044560&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21044560"]])

export default __exports__